import { render, staticRenderFns } from "./ViewDraft.vue?vue&type=template&id=12e5ec76&"
import script from "./ViewDraft.vue?vue&type=script&lang=js&"
export * from "./ViewDraft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports